import { formatDate } from '@/features/common/formatDate';

/**
 * How a project's budget and period are written, wherever a project is shown.
 *
 * Shared because the same project is now printed twice: the organisation reads it in its own
 * cabinet, and a visitor reads it on the public catalogue page. Two copies of "amount, thousands
 * separator, MDL" drift the moment one of them is corrected — the same reason CalendarRow exists.
 */

/** An amount in lei, as the registry records it; empty when the project never stated one. */
export function formatBudget(value: number | null): string {
  return value == null ? '' : `${value.toLocaleString('ro-RO')} MDL`;
}

/**
 * The two dates as one line.
 *
 * Empty when neither is known, and half-open when only one is — a project that has started and
 * has no agreed end is an ordinary state, not missing data, so the dash stands with nothing after
 * it rather than the line being withheld.
 */
export function formatPeriod(
  startDate: string | null,
  endDate: string | null,
  language: string,
): string {
  if (!startDate && !endDate) return '';
  return `${formatDate(startDate, language)} – ${formatDate(endDate, language)}`;
}
